/**
 * Full page load. Used when the signed-in identity changes (entering or leaving
 * «Войти как автор»), so no cached data of the previous account survives.
 */
export function hardNavigate(url: string): void {
  window.location.assign(url);
}
